import { buildCurrencyApiConfig } from './currency.api.js';
import { LOAD_STATE } from '../../../shared/axios';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const GET_CURRENCY = '@pricing/currency/GET_CURRENCY';
export const CURRENCY_REQUEST_CALLED = '@pricing/currency/CURRENCY_REQUEST_CALLED';
export const CURRENCY_REQUEST_SUCCEEDED = '@pricing/currency/CURRENCY_REQUEST_SUCCEEDED';
export const CURRENCY_REQUEST_FAILED = '@pricing/currency/CURRENCY_REQUEST_FAILED';

export const getCurrenciesData = state => state.pricing.currency.data;

export const getCurrencies = () => ({
    type: GET_CURRENCY,
    payload: {},
});

export const getCurrenciesRequest = () => ({
    type: CURRENCY_REQUEST_CALLED,
    actionTypes: {
        success: CURRENCY_REQUEST_SUCCEEDED,
        fail: CURRENCY_REQUEST_FAILED,
    },
    config: buildCurrencyApiConfig(),
});

const initialState = {
    data: [],
    loadState: LOAD_STATE.LOADING,
    error: null,
};
export const currencyReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [CURRENCY_REQUEST_CALLED]: state => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [CURRENCY_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: action.payload.data.currencies,
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [CURRENCY_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: action.error,
        loadState: LOAD_STATE.FAIL,
        error: null,
    }),
});
